<template>
  <div class="shop">
   <el-form ref="filtrateForm" :inline="true" size="mini" :model="form" class="form">
      <el-form-item label="操作类型:">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option label="全部" value='0'></el-option>
          <el-option
            v-for="(item, index) in typeList"
            :key="item.id+''+index"
            :label="item.text"
            :value="item.type"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值时间:">
        <el-row>
          <el-col :span="18">
            <el-date-picker
              v-model="pickerTime"
              type="daterange"
              align="right"
              unlink-panels
              format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="timeOptions"
            ></el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>
      <el-button size="mini" type="primary" @click="searchLogData">搜索</el-button>
   </el-form>
   <el-table
      :data="tableData"
 
      :cell-style="tc"
      :header-cell-style="tccolor"
      v-loading="listLoading"
    >
      <el-table-column fixed prop="created_at" label="操作时间"></el-table-column>
      <el-table-column prop="operator" label="登录账号"></el-table-column>
      <el-table-column prop="type_text" label="操作类型"></el-table-column>
      <!-- <el-table-column prop="charge_time" label="操作详细"></el-table-column> -->
      <el-table-column prop="remark" label="备注" ></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :current-page="form.page"
        :page-sizes="[20, 50, 100]"
        :page-size="form.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils/index";
import {shopAdminLogType,shopAdminLog} from '@/api/shopdetail'
export default {
  data () {
    return {
      form: {
        type: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 20
      },
      total: 100,
      listLoading: false,
      tableData: [],
      typeList:[],
      timeOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },

          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近15天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      pickerTime: "",
    }
  },
  mounted () {
    this.getshopAdminLogTypeData()
    this.getList()
  },
  methods: {

   searchLogData(){
   this.getList()
   },
       // 导出
   out() {
      const form = this.form;
      if (this.pickerTime !== "" && this.pickerTime !== null) {
        form.start_time = parseTime(
          this.pickerTime[0],
          "yyyy-MM-dd hh:mm:ss"
        );
        form.end_time = parseTime(
          this.pickerTime[1],
          "yyyy-MM-dd hh:mm:ss"
        );
      } else {
        form.start_time = ''
        form.end_time = ''
      }
    },
    pageChange(page) {
      this.form.page = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.pageChange(1);
    },

    tc() {
      return "text-align:center; color:#333333; font-size:12px;";
    },
    tccolor() {
      return "text-align:center;background-color:#f5f5f5; font-size:14px;";
    },
    async getshopAdminLogTypeData(){
      let  res = await shopAdminLogType()
      if(res.code === 10000){
         this.typeList = res.data
      }
    },
    async getList () {
      const form = this.form;
      console.log(this.pickerTime);
      if (this.pickerTime !== "" && this.pickerTime !== null) {
        form.start_time = parseTime(this.pickerTime[0], "yyyy-MM-dd hh:mm:ss");
        form.end_time = parseTime(this.pickerTime[1], "yyyy-MM-dd hh:mm:ss");
      }  else {
        form.start_time = ''
        form.start_time = ''
      }
      if(this.form.type == 0){
        this.form.type = ''
      }
      this.listLoading = true;
      let res = await shopAdminLog(this.form)
      if(res.code === 10000){
        this.tableData = res.data.data
        this.total = res.data.total
        this.listLoading = false

      }else{
        this.listLoading = false
        this.$message.error(res.message)
      }
    },
  
  }
}
</script>

<style lang="scss" scoped>
.shop {
  padding: 20px;
  .form{
    float: right;
  }
  .pagination{
    float: right;
    margin-top: 30px;
  }
}
</style>